import { Fragment, useState } from 'react';

import { Button } from '@xing-com/button';

import type { HtmlSerializerProps } from '../../utils/html-serializer';
import htmlSerializer from '../../utils/html-serializer';

import Styled from './iframe-prescreen.styles';

interface IframePrescreenProps {
  introScreen?: HtmlSerializerProps['content'][];
  url: string;
  title?: string;
  onClose: () => void;
  introScreenButtonText?: string;
  introScreenButtonAriaLabel?: string;
}

const IframePrescreen = ({
  introScreen,
  url,
  title,
  onClose,
  introScreenButtonText = 'next',
  introScreenButtonAriaLabel,
}: IframePrescreenProps): JSX.Element => {
  const [showIframe, setShowIframe] = useState<boolean>(false);

  return showIframe || !introScreen ? (
    <Styled.FullSizeIframe
      src={url}
      sandbox={'allow-scripts allow-same-origin'}
      title={title}
    ></Styled.FullSizeIframe>
  ) : (
    <Styled.IntroScreenContainer>
      {introScreen?.map((content, index) => (
        <Fragment key={`iframe-survey-${index}`}>
          {htmlSerializer({
            content,
            onClose,
          })}
        </Fragment>
      ))}
      <Styled.ButtonContainer>
        <Button
          onClick={() => {
            setShowIframe(true);
          }}
          variant={'primary'}
          aria-label={introScreenButtonAriaLabel || introScreenButtonText}
        >
          {introScreenButtonText}
        </Button>
      </Styled.ButtonContainer>
    </Styled.IntroScreenContainer>
  );
};

export default IframePrescreen;
